export default __webpack_public_path__ + "static/media/flow_updated.d50d387a.svg";